import { useContext } from 'react';
import { MonthView } from '@devexpress/dx-react-scheduler-material-ui';
import { RutinSettingsContext } from '../../../../../../_Common/Components/RutinAvailabilityContext/RutinAvailabilityContext';
import { SchedulerContext } from '../../SchedulerContext';
import { makeStyles } from 'tss-react/mui';
import { nyAktivitetInitialValues } from '../Utils/NyAktivitetInitialValues';
import { NewId } from '../../../../../../../../Components/MasterDetail/MasterDetailUtils';
import { ViewDbSettingsContext } from '../ViewDbSettingsContext';

const useStyles = makeStyles()(theme => ({
  redDay: {
    '& .Cell-text': { color: 'red' },
  },
}));

export const MonthViewTimeTableCellComponent = (
  props: MonthView.TimeTableCellProps
) => {
  const { classes, cx } = useStyles();
  const schedulerContext = useContext(SchedulerContext);
  const rutinSettingsContext = useContext(RutinSettingsContext);
  const resourceContext = useContext(ViewDbSettingsContext);

  const cellDay = props.startDate.toLocaleDateString('sv-SE', {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  });

  const redDay = Boolean(
    schedulerContext.redDays.find(
      day =>
        day.toLocaleDateString('sv-SE', {
          year: 'numeric',
          month: 'numeric',
          day: 'numeric',
        }) === cellDay
    )
  );

  return (
    <MonthView.TimeTableCell
      className={cx({
        [classes.redDay]: redDay,
      })}
      {...props}
      onDoubleClick={() => {
        if (
          resourceContext?.resources?.find(res => res.kanBoka) ||
          resourceContext.loggedInUserResource?.kanBoka
        ) {
          schedulerContext.setNyAktivitetInitialValues(
            nyAktivitetInitialValues(
              props.startDate,
              props.startDate,
              false,
              props.groupingInfo?.[0].id,
              schedulerContext,
              rutinSettingsContext
            )
          );
          schedulerContext.onSelectDetail?.(NewId);
        }
      }}
      onFocus={() => {
        schedulerContext.setNyAktivitetInitialValues(
          nyAktivitetInitialValues(
            props.startDate,
            props.startDate,
            false,
            props.groupingInfo?.[0].id,
            schedulerContext,
            rutinSettingsContext
          )
        );
      }}
      onBlur={() => {}}
    ></MonthView.TimeTableCell>
  );
};
